import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Image from "./other/Image";
import Spinner from "./other/Spinner";
import Loading from "./other/Loading.vue";

export const registerComponents = (app, theme) => {
  app.component("c-img", Image);
  app.component("c-img-lazy", Image);
  app.component("font-awesome-icon", FontAwesomeIcon);
  app.component("Spinner", Spinner);
  app.component("Loading", Loading);
};
